import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ResetPasswordComponent } from './reset-password.component';

const routes: Routes = [
  {
    path: ':resetPasswordToken',
    component: ResetPasswordComponent,
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ResetPasswordRoutingModule {}
